import {IRevolutPromotionalWidgetControllerViewModel} from "./revolut-payment-controller.view-model.interface";
import {RevolutUpsellModuleInstance, WidgetUpsellPromotionalBannerOptions} from "@revolut/checkout";
import {BookingModel} from "../../../booking.model";


export class RevolutPromotionalWidgetController implements IRevolutPromotionalWidgetControllerViewModel {

    constructor(private readonly revolutUpsellModule: RevolutUpsellModuleInstance,
                private readonly booking: BookingModel) {
    }

    mount(element: HTMLElement): void {
        this.revolutUpsellModule.promotionalBanner.mount(element, this._getUpsellOptions())
    }
    dispose(): void {
        this.revolutUpsellModule.destroy();
    }

    private _getUpsellOptions(): WidgetUpsellPromotionalBannerOptions {
        return {
            variant: 'banner',
            currency: this.booking.currency,
            amount: this.booking.balanceDue.amountToCents(),
        }
    }

}